import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './plugins/store';
import {pushInterceptor} from './plugins/axios';
import auth from "./auth";

import './scss/app.scss';

Vue.config.productionTip = false
Vue.use(auth);

pushInterceptor(Vue.axios, store);

new Vue({
    vuetify,
    router,
    store,
    render: h => h(App)
}).$mount('#app')
